import Link from 'next/link';
const Logo = (props) => {
    console.log(props);
    return <img src="/img/logo.png" alt="Logo" className='logo_image'
     width={props.width || "auto"} height={props.height || "'auto"}/>
}
export default Logo